import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { getHealth } from "./StatusClient";

export const Connection = {
	CONNECTED: "CONNECTED",
	UNSTABLE: "UNSTABLE",
	DISCONNECTED: "DISCONNECTED"
} as const;

export type ConnectionType = (typeof Connection)[keyof typeof Connection];

export type Status = {
	connection: ConnectionType;
};

export const useStatus = () => useContext(StatusContext);

export const StatusContext = createContext<Status>({
	connection: Connection.CONNECTED
});

type StatusProviderProps = {
	children?: React.ReactNode;
};

export function StatusProvider(props: Readonly<StatusProviderProps>) {
	const [connection, setConnection] = useState<ConnectionType>(
		Connection.CONNECTED
	);

	const status: Status = useMemo(() => ({ connection }), [connection]);

	useEffect(() => {
		const id = setInterval(() => checkHealth(), 3000);

		return () => {
			clearInterval(id);
		};
	}, [connection]);

	function checkHealth(): void {
		const start = performance.now();
		getHealth()
			.then(() => {
				const end = performance.now();
				const duration = end - start;
				if (duration < 500) {
					setConnection(Connection.CONNECTED);
				} else {
					setConnection(Connection.UNSTABLE);
				}
			})
			.catch(() => setConnection(Connection.DISCONNECTED));
	}

	return (
		<StatusContext.Provider value={status}>
			{props.children}
		</StatusContext.Provider>
	);
}
